"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupporterInfo = void 0;
var react_1 = __importDefault(require("react"));
var colors_1 = require("../../../constants/colors");
var supporterInfo_1 = require("../../../constants/molecules/supporterInfo");
var SvgSpriteLoader_1 = __importDefault(require("../SvgSpriteLoader"));
var TYPE_PROP = (_a = {},
    _a[supporterInfo_1.SUPPORT_INFO_TYPES.GUIDE] = {
        iconByType: null,
        iconColorByType: colors_1.COLORS.TEXT_SECONDARY,
        textClassByType: 'f-12-300 tw-text-TEXT_SECONDARY',
    },
    _a[supporterInfo_1.SUPPORT_INFO_TYPES.ERROR] = {
        iconByType: null,
        iconColorByType: colors_1.COLORS.RED_PRIMARY,
        textClassByType: 'f-12-300 tw-text-RED_PRIMARY',
    },
    _a[supporterInfo_1.SUPPORT_INFO_TYPES.CUSTOM] = {
        iconByType: null,
        iconColorByType: '',
        textClassByType: '',
    },
    _a);
var SupporterInfo = function (_a) {
    var _b, _c;
    var _d = _a.type, type = _d === void 0 ? supporterInfo_1.SUPPORT_INFO_TYPES.GUIDE : _d, _e = _a.icon, icon = _e === void 0 ? null : _e, _f = _a.text, text = _f === void 0 ? null : _f, _g = _a.showIcon, showIcon = _g === void 0 ? true : _g, _h = _a.showText, showText = _h === void 0 ? true : _h, _j = _a.wrapperClass, wrapperClass = _j === void 0 ? 'tw-flex tw-items-center' : _j, _k = _a.iconClass, iconClass = _k === void 0 ? 'tw-mr-2 tw-w-3 tw-h-3' : _k, _l = _a.iconAttributes, iconAttributes = _l === void 0 ? { id: '' } : _l, _m = _a.textClass, textClass = _m === void 0 ? null : _m, _o = _a.iconColor, iconColor = _o === void 0 ? null : _o, id = _a.id;
    var _p = TYPE_PROP[type] || {}, iconByType = _p.iconByType, iconColorByType = _p.iconColorByType, textClassByType = _p.textClassByType;
    var typeIcon = (_b = icon !== null && icon !== void 0 ? icon : iconByType) !== null && _b !== void 0 ? _b : null;
    var typeTextClass = (_c = textClass !== null && textClass !== void 0 ? textClass : textClassByType) !== null && _c !== void 0 ? _c : '';
    var typeIconColor = iconColor !== null && iconColor !== void 0 ? iconColor : iconColorByType;
    return (react_1.default.createElement(react_1.default.Fragment, null, (showIcon || showText) && (react_1.default.createElement("div", { className: wrapperClass, "data-testid": "supporter-info-" + id },
        showIcon && (typeIcon || iconAttributes.id) && (react_1.default.createElement("div", { className: iconClass, "data-testid": "supporter-info-icon-wrapper-" + id },
            react_1.default.createElement(SvgSpriteLoader_1.default, __assign({ color: typeIconColor }, iconAttributes, { id: typeIcon !== null && typeIcon !== void 0 ? typeIcon : iconAttributes.id })))),
        showText && text && (react_1.default.createElement("div", { className: typeTextClass, "data-testid": "supporter-info-text-" + id }, text))))));
};
exports.SupporterInfo = SupporterInfo;
